

import React, { useEffect, useContext, useState } from 'react';
import { Flex, Row, message, Divider, Modal, Tabs } from 'antd';
import dayjs from 'dayjs';
import { CheckOutlined } from '@ant-design/icons';
import can from '../../../../components/ability';

const iconStyle = {
    fontSize: 28,
}


function CardShow(props) {
    const { data, choose, onClick } = props;

    
    const {
        title, type, description, good
    } = data;
    return (
        <div className={`dialog-info-item-coupon ${choose?'choose':''}`} onClick={() => onClick(data)}>
            <div className='choose-text'>次卡名称: {title}</div>
            <div>描述：{description}</div>
            <div>关联商品名称：{good?.title}</div>
            {choose?<CheckOutlined className='chose-icon' />: null}
        </div>
    )
}

export default (props) => {
    
    const { value, onChange, onClose, multi = true, visible, list = [] } = props;
    const [chooseList, setChooseList] = useState([]);
    useEffect(() => {
        let list = [];
        if (!value || value.length <= 0) {
            setChooseList([]);
            return;
        }
        if (Array.isArray(value)) {
            if (multi) {
                list = value;
            } else {
                list = [value[0]];
            }
        } else {
            list = [value];
        }
        setChooseList(list);
        return;
    }, [value, visible]);

    function onClickOne(data) {
        const id = data.cardTmpId;
        if (!multi) {
            setChooseList([id])
            return;
        }
        const index = chooseList.indexOf(id);
        let list  = []
        if (index >= 0) {
            chooseList.splice(index, 1)
        } else {
            chooseList.push(id);
        }
        list = [...chooseList];
        setChooseList(list);
    }

    function handleOk() {
        onChange(chooseList)
    }

    
    return (
        <div>
            <Modal
                title="选择次卡"
                open={visible}
                onOk={handleOk}
                onCancel={onClose}
            >
              <div className='dialog-show-item-content'>
                {
                    list.map(i => <CardShow key={i.cardTmpId} data={i} choose={chooseList.indexOf(i.cardTmpId) >= 0} onClick={onClickOne} />)
                }
              </div>
            </Modal>
        </div>
    );
};